/**
 * describeGoalTiming — localised "X months ahead" / "N days past deadline"
 * copy for a completed goal. Returns null when the goal has no deadline
 * or the date can't be parsed. Extracted from GoalCompleteModal.jsx.
 */
export function describeGoalTiming(goal, t) {
  if (!goal?.deadline) return null;
  try {
    const d = new Date(goal.deadline);
    const now = new Date();
    const days = Math.round((d.getTime() - now.getTime()) / 86400000);
    if (days > 30) {
      const months = Math.round(days / 30);
      return months === 1
        ? t("goal_complete_modal.timing_month_ahead")
        : t("goal_complete_modal.timing_months_ahead", { count: months });
    }
    if (days > 0) {
      return days === 1
        ? t("goal_complete_modal.timing_day_ahead")
        : t("goal_complete_modal.timing_days_ahead", { count: days });
    }
    if (days === 0) return t("goal_complete_modal.timing_on_target");
    const past = -days;
    return past === 1
      ? t("goal_complete_modal.timing_day_past")
      : t("goal_complete_modal.timing_days_past", { count: past });
  } catch { return null; }
}
